/* 🤖 this file was generated by svg-to-ts*/
export const iconArrowPanel: {
  name: 'arrow_panel';
  data: string;
} = {
  name: 'arrow_panel',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M1 0a1 1 0 00-1 1v22a1 1 0 002 0V1a1 1 0 00-1-1zm12.625 6.219a1.002 1.002 0 00-1.407.157l-4 5c-.037.046-.055.099-.083.15-.021.039-.046.073-.063.115a.991.991 0 000 .719c.017.042.042.076.063.115.028.05.046.105.083.15l4 5a1.005 1.005 0 001.407.157c.43-.346.501-.975.156-1.406L11.08 13H23a1 1 0 000-2H11.08l2.701-3.375a1.003 1.003 0 00-.156-1.407z"/></svg>`,
};
